import { wait } from 'modules-core/utility'
import { createAudioEffect } from '.'
import { createDefaultEffectParams } from '../constants'
import { AudioEffect } from '../types'
import { rampToValueAtTime, setValueCurveAtTime } from '../utility'
import config from 'modules-core/config'
import { gainToVolume, volumeToGain } from '../volumeCurve'

export const createVolumeEffect = (params: AudioEffect.VolumeEffectParams = {}) => {
	params = Object.assign(createDefaultEffectParams('volume'), params)
	if (params.isDestination)
		params.output = undefined

	const node = new GainNode(config.audioContext, { gain: params.volume })

	// const normalizeVal = (val: number) => MathExt.clamp(val, minSafeAudioNumber, maxSafeAudioNumber)

	// Gain 1 is "reference level" (dBFS) and the maximum we should ever send to the audio
	// destination. Here we convert volume expressed as a percentage to dBFS, and then to
	// gain, to give us an exponential volume control that behaves more like we expect.

	const effect: AudioEffect.VolumeEffect = {
		params,
		...createAudioEffect(node),
		get value() { return gainToVolume(node.gain.value) },
		set value(val) {
			node.gain.cancelScheduledValues(config.audioContext.currentTime)
			node.gain.value = volumeToGain(val)
		},
		fadeToValue: async (
			val,
			durationSecs = params.fadeDuration,
			curveName,
			startTime = config.audioContext.currentTime,
		) => {
			rampToValueAtTime(
				node.gain,
				volumeToGain(val),
				startTime,
				durationSecs,
				curveName,
			)
			await wait(durationSecs * 1000)
		},
		fadeToValueCurve: async (
			values,
			durationSecs = params.fadeDuration,
			startTime = config.audioContext.currentTime,
		) => {
			setValueCurveAtTime(node.gain, values, startTime, durationSecs)
			await wait(durationSecs * 1000)
		},
		setParam: {
			'volume': (val) => node.gain.value = val,
			'fadeDuration': val => params.fadeDuration = val
		},
		// fadeToValueAtTimestamp: async (val: number, timestamp: number) =>{
		//	 const duration =
		//	 rampSafely(val, context.currentTime + timestamp - MathExt.millisToSecs(getServerTime())),
		//	 await wait(durationSecs * 1000)
		// }
	}
	return effect
}
